// capitalizes the first letter of a string
export const capitalizeFirst = (str?: string | null): string => {
  if (!str) return '' // handles null, undefined, or empty string
  return str.charAt(0).toUpperCase() + str.slice(1)
}
